import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="material-line" — one material row. Reacts to
// its own "Material" combobox's selection: picking a real catalog article
// auto-fills name/unit/price from it and hides the price field (the catalog
// price is fixed, not user-editable, but its value still submits since the
// field is only hidden, never disabled); picking "Custom material" (or
// nothing) leaves/reverts everything to free-text entry.
export default class extends Controller {
  static targets = ["articleCombobox", "name", "unit", "price", "priceWrapper"]

  applyArticle() {
    const article = this.selectedArticleOption()

    if (!article) {
      const combobox = this.application.getControllerForElementAndIdentifier(this.articleComboboxTarget, "combobox")
      if (combobox?.newSelectionName()) this.nameTarget.value = combobox.newSelectionName()
      this.priceWrapperTarget.hidden = false
      return
    }

    this.nameTarget.value = article.dataset.materialName
    this.unitTarget.value = article.dataset.materialUnit
    this.priceTarget.value = article.dataset.materialPrice
    this.priceWrapperTarget.hidden = true
  }

  selectedArticleOption() {
    const combobox = this.application.getControllerForElementAndIdentifier(this.articleComboboxTarget, "combobox")
    if (!combobox) return null

    const option = combobox.selectedOption()
    return option && option.dataset.materialName !== undefined ? option : null
  }
}
